<template>
  <section
    class="component-aa599ce7"
    resmed-component-name="warranty-information"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row">
          <div class="col">
            <div class="introduction">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <h2>{{ acf.headline }}</h2>
              <div v-html="acf.description"></div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="wrapper">
              <h2>{{ acf.warranty.headline }}</h2>
              <div class="mb-5" v-html="acf.warranty.description"></div>

              <div class="items">
                <div class="item" v-for="item in acf.warranty.product">
                  <span class="period-label mb-3 d-inline-block">
                    {{ item.period }}
                  </span>
                  <div class="content" v-html="item.content"></div>
                </div>
              </div>
            </div>

            <div class="disclaimer" v-html="acf.warranty.disclaimer"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-aa599ce7", // warranty-information
  props: ["acf"],
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-aa599ce7 {
  padding: 5rem 0;

  @media (min-width: 768px) {
    padding: 7rem 0;
  }
}

.component {
  h2 {
    position: relative;
    margin-bottom: 1.125rem;

    @extend %eyebrow-left;
  }

  .item {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid rgba($cc-resmed-grey-30, 0.75);

    .period-label {
      letter-spacing: 0.58px;
      padding: 0.625rem 1rem;
      background-color: rgba($cc-resmed-grey-50, 0.325);
    }
  }

  %padding {
    padding: 4rem 2rem 2rem 2rem;

    @media (min-width: 768px) {
      padding: 5rem 5rem 4rem 5rem;
    }

    @media (min-width: 992px) {
      padding: 5rem 12rem 5rem 6rem;
    }
  }

  .introduction {
    @extend %padding;
    padding-top: 0;

    @media (max-width: 767px) {
      padding: 0 1rem 3rem 1rem;
    }

    @media (min-width: 1200px) {
      padding: 0 12rem 6rem 6rem;
    }
  }

  .wrapper {
    background-color: $cc-resmed-white;
    border-radius: 6px;

    @extend %padding;
  }

  .disclaimer {
    @extend %padding;

    @media (max-width: 767px) {
      padding: 2rem 1rem 0 1rem;
    }

    @media (min-width: 768px) {
      padding-top: 3rem;
    }

    @media (min-width: 992px) {
      padding-top: 4rem;
      padding-bottom: 0;
    }
  }
}
</style>